export { default } from './OverflowTextSection';



// WEBPACK FOOTER //
// ../react-lib/src/pages/pets/PetProfilePage/components/OverFlowTextSection/index.js